import { render } from "./AllSlides.vue?vue&type=template&id=3d52f82a&scoped=true"
import script from "./AllSlides.vue?vue&type=script&lang=js"
export * from "./AllSlides.vue?vue&type=script&lang=js"

import "./AllSlides.vue?vue&type=style&index=0&id=3d52f82a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d52f82a"]])

export default __exports__